import { keyAttachments, status } from '~/helpers/fields-description';
import { batteryPercent } from '~/helpers/nsd-fields-description';
import { Gateway } from '~/models/gateways/gateway.model';
import { HomesModule } from '~/store/modules/homes';

type Attachment = { id: string, setup_date: number }
export class NDL extends Gateway {
    hasOperationMainloop = false;
    battery_percent?: number;
    attachments_linked?: Attachment[]

    get fieldLastReset() {
        return undefined;
    }
    get fieldStatus() {
        return status(this.status);
    }
    get fieldBatteryPercent() {
        return batteryPercent(this.battery_percent);
    }
    get fieldKeyAttachments() {
        return keyAttachments(this.keyAttachments);
    }

    get keyAttachments() {
        const homeAttachments = HomesModule.currentHome?.attachments || [];
        return this.attachments_linked?.map(attachment => {
            const attachmentInfo = homeAttachments.find(_attachment => _attachment.id === attachment.id);
            return { ...attachment, name: attachmentInfo?.name || 'no name' };
        }) || [];
    }
}
